import Axios from 'axios';
import { APIBASE_URL, SALARYDEDUCTION } from "../config/cacheKey";
import { ApiResultModel } from "../models/common.model";
import { IRefrenceKeyRequest } from "../models/registration.model";
import { IGetSalaryDeductionResponse } from "../models/salaryDeduction.model";
export const GetSalaryDeductionFormInfo = (data: IRefrenceKeyRequest): Promise<ApiResultModel<IGetSalaryDeductionResponse>> => {
    return Axios.post<ApiResultModel<IGetSalaryDeductionResponse>>(
        APIBASE_URL + SALARYDEDUCTION + '/GetSalaryDeductionFormInfo',
        data
    ).then((result) => {
        return result.data;
    });
};

export const GoForward = (data: IRefrenceKeyRequest): Promise<ApiResultModel<boolean>> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + SALARYDEDUCTION + '/GoForward',
        data
    ).then((result) => {
        return result.data;
    });
};